import MyDashboard from "../ui-components/MyDashboard";
import OtherKeySites from "../ui-components/OtherKeySites";
import Container from "@mui/material/Container";
import FeedbackBanner from "../ui-components/FeedbackBanner";

export default function Home() {
  return (
    <Container>
      <FeedbackBanner />
      <MyDashboard />
      <OtherKeySites />
    </Container>
  );
}
